export default "__VITE_ASSET__CmhLdxMS__"